import {useTheme} from '@mui/material';
import type {SxProps} from '@mui/system';
import {Layout} from 'components/layout';
import {Text} from 'components/text';

type Props = {
  code: string;
};

export const ThesaurusCode: React.FC<Props> = ({code}) => {
  const {colors} = useTheme();

  const sx: SxProps = {
    borderRadius: 1,
    background: colors.beige,
    padding: 1,
  };

  return (
    <Layout sx={sx}>
      <Text kind="primary" variant="body2">
        {code}
      </Text>
    </Layout>
  );
};
